import React from "react";

function Rule() {
  return (
    <>
      <div className="flex flex-col  items-center sm:px-16 p-6">
        <h1 className="text-[1.9rem] font-bold tracking-wide ">
          <span className="text-[#01A7D1] ">Housing</span> Rule
        </h1>
        <p className="text-md  text-[#444444] tracking-wide pt-3 ">
          These House Rules (Rules) must be followed by all the residents
          staying in any property (House) operated by Yostel Management
          (“Yostel”). Any breach or violation of these Rules will amount to a
          breach of the Resident Agreement entered by the resident with Yostel
          and may trigger Yostel’s rights to terminate the agreement. These
          rules may be updated from time to time by Yostel at its sole
          discretion.
        </p>
      </div>
    </>
  );
}

export default Rule;
